<template>
    <div class="card">
        <DataTable
            :value="allPermissions"
            :lazy="true"
            :paginator="true"
            :rows="10"
            ref="dt"
            dataKey="id"
            :totalRecords="totalRecords"
            :loading="loading"
            @page="onPage($event)"
            responsiveLayout="scroll"
            :globalFilterFields="['code', 'description']"
            :rowsPerPageOptions="[5, 10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <!-- <template #header>
                <div class="flex justify-content-between">
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined" @click="clearFilter()" />
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Search Permissions" />
                    </span>
                </div>
            </template> -->

            <template #empty> No Permissions Available. </template>

            <Column field="id" header="SN" ref="id" />
            <Column field="code" header="CODE" ref="code" />
            <Column field="description" header="DESCRIPTION" ref="description" />
            <Column field="active" header="ACTIVE" ref="active">
                <template #body="slotProps">
                    <span class="p-column-title">ACTIVE</span>
                    <Tag :value="isActive(slotProps.data.active)" :severity="isActive(slotProps.data.active) ? 'success' : 'danger'" :rounded="true"></Tag>
                </template>
            </Column>
            <Column field="created_at" header="CREATED AT" ref="created_at">
                <template #body="slotProps">
                    <span class="p-column-title">ACTIVE</span>
                    {{ slotProps.data.created_at }}
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { permissionStore } from '@/store/global-stores';
import { storeToRefs } from 'pinia';

const { params, totalRecords, loading, allPermissions } = storeToRefs(permissionStore);

onMounted(async () => {
    await loadPermissions();
});

const loadPermissions = async () => {
    const paginate = true;
    await permissionStore.fetchAllPermissions(params.value, paginate);
};

const isActive = (active) => {
    return active === 1;
};

const onPage = async (event) => {
    params.value.page_size = event.rows;
    // by default event.page starts from 0 so we will add 1
    params.value.page = event.page + 1;
    await loadPermissions(params.value);
};
</script>
